export const CONFIGURATION_GROUP_KEY = {
  PARTICIPANT_MANAGEMENT: 'PARTICIPANT_MANAGEMENT',
  CERTIFICATE: 'CERTIFICATE',
} as const

export type ConfigurationGroupKey =
  (typeof CONFIGURATION_GROUP_KEY)[keyof typeof CONFIGURATION_GROUP_KEY]

export type ProgramImportConfigurationRequest = {
  sourceProgramId: string
  listConfigurationType: ConfigurationType[]
}

export type ConfigurationType =
  | 'PROGRAM_CONFIGURATION_BLUEPRINT_REGISTRATION'
  | 'PROGRAM_CONFIGURATION_AUTO_APPROVE_DIKLAT_PARTICIPANTS'
  | 'PROGRAM_CONFIGURATION_HIDE_ADD_PARTICIPANT'
  | 'PROGRAM_CONFIGURATION_MODIFY_PROFILE'
  | 'PROGRAM_CONFIGURATION_AUTO_APPROVE_MODIFY_PROFILE'
  | 'PROGRAM_CONFIGURATION_GRADE_SETTINGS'
  | 'PROGRAM_CONFIGURATION_SELF_ENROLLMENT'
  | 'PROGRAM_CONFIGURATION_UMPAN_BALIK'
  | 'PROGRAM_CONFIGURATION_CERTIFICATE_DESIGN_TEMPLATES'
  | 'PROGRAM_CONFIGURATION_CERTIFICATE_PREREQUISITES'

export type ConfigurationTreeKey = ConfigurationType | ConfigurationGroupKey
